import React from 'react'
import { HelpModal } from '../../help/help-modal.component'

export const AcademicRecordHelp = ({modalRef}) =>
  <HelpModal innerRef={modalRef} title="Next semester's financial aid depends on your grades">
    To qualify for financial aid, you need to meet Satisfactory Academic Progress requirements. FutureGrad uses the
    information below to calculate the requirements based on your GPA, credits and other factors.
  </HelpModal>